// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import ProfessionalGovernanceHeroImg from "../../asset/Accounting.png"; // Hero background image (replace if needed)
// import ProfessionalGovernanceCenterImg from "../../asset/image1.png"; // Center image for Professional Governance
// import ProfessionalGovernanceRightImg from "../../asset/image9.png"; // Right-side image for services section
// import LineImg from "../../asset/line1.png"; // Line image
// import pointImg from "../../asset/point.png"; // Icon for points
// import "./ServiceBusiness.css"; // Create or reuse existing CSS

// const ServiceProfessionalGovernance = () => {
//   return (
//     <div>
//       {/* Hero Section */}
//      <div
//        className="services-hero"
//        style={{
//          backgroundImage: `url(${ProfessionalGovernanceHeroImg})`,
//          backgroundSize: "cover",
//          backgroundPosition: "center",
//          height: "88vh",
//          position: "relative",
//          display: "flex",
//          alignItems: "center",
//          justifyContent: "center",
//          textAlign: "center",
//        }}
//      >
//        {/* Dark Overlay */}
//        <div className="services-overlay"></div>
     
//        {/* Hero Content */}
//        <div className="services-content">
//          <h1 className="services-heading">Building Trust Through Transparency</h1>
//          <p className="services-paragraph">
//            We deliver through audits and assurance services that enhance credibility,
//            accuracy and confidence for your stakeholders.
//          </p>
//        </div>
//      </div>


//       {/* Professional Governance Image Section */}
//       <div className="detail-section">
//         <Container className="text-center">
//           <div className="d-flex align-items-center justify-content-center flex-wrap">
//             <img src={LineImg} alt="line-left" className="side-line" />

//             <div className="center-image-wrapper">
//               {/* <img
//                 src={ProfessionalGovernanceCenterImg}
//                 alt="Professional Governance Services"
//                 className="side-image"
//               /> */}
//               <div className="image-text">Other Professional Services</div>
//             </div>

//             <img src={LineImg} alt="line-right" className="side-line mirrored" />
//           </div>
//         </Container>
//       </div>

//       {/* Service Points Section */}
//       <div className="service-image-section">
//         <Container>
//           <Row className="align-items-center">
//             {/* Left Column with Points */}
//             <Col md={6}>
//               <ul className="service-points">
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Periodic Internal Audit Monitoring
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Corporate Planning & Business Transformation
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Market Study & Competition Analysis
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Feasibility Studies & Project Evaluation
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Cost optimisation & Performance Improvement
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Variance & Sensitivity Analysis
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Certifications & Advisory Service
//                 </li>
//               </ul>
//             </Col>

//             {/* Right Column with Image */}
//             <Col md={6} className="text-center text-md-end">
//               <img
//                 src={ProfessionalGovernanceRightImg}
//                 alt="Professional Governance Detail"
//                 className="service-right-image"
//               />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </div>
//   );
// };

// export default ServiceProfessionalGovernance;

import React, { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProfessionalGovernanceRightImg from "../../asset/professional.webp"; // Right-side image
import LineImg from "../../asset/line1.png";                          // Decorative line
import professionalImg from "../../asset/Accounting.webp";
import pointImg from "../../asset/point.png";                         // Icon for points
import "./ServiceBusiness.css";

// ✅ Memoized service point component
const ServicePoint = memo(({ text }) => (
  <li>
    <img src={pointImg} alt="icon" className="point-icon" loading="lazy" />
    {text}
  </li>
));

const ServiceProfessionalGovernance = () => {
  const servicePoints = [
    "Periodic Internal Audit Monitoring",
    "Corporate Planning & Business Transformation",
    "Market Study & Competition Analysis",
    "Feasibility Studies & Project Evaluation",
    "Cost optimisation & Performance Improvement",
    "Variance & Sensitivity Analysis",
    "Certifications & Advisory Service",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div className="services-hero professional-governance-hero"
       style={{
    backgroundImage: `url(${ professionalImg })`, // ✅ Use template literal with imported image
  }}>
        <div className="services-overlay"></div>
        <div className="services-content">
          <h1 className="services-heading">Building Trust Through Transparency</h1>
          <p className="services-paragraph">
            We deliver through professional governance services that enhance credibility,
            accuracy and confidence for your stakeholders.
          </p>
        </div>
      </div>

      {/* Center Section */}
      <div className="detail-section">
        <Container className="text-center">
          <div className="d-flex align-items-center justify-content-center flex-wrap">
            <img src={LineImg} alt="line-left" className="side-line" loading="lazy" />
            <div className="center-image-wrapper">
              <div className="image-text">Other Professional Services</div>
            </div>
            <img src={LineImg} alt="line-right" className="side-line mirrored" loading="lazy" />
          </div>
        </Container>
      </div>

      {/* Service Points Section */}
      <div className="service-image-section">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <ul className="service-points">
                {servicePoints.map((point, index) => (
                  <ServicePoint key={index} text={point} />
                ))}
              </ul>
            </Col>

            <Col md={6} className="text-center text-md-end">
              <img
                src={ProfessionalGovernanceRightImg}
                alt="Professional Governance Detail"
                className="service-right-image"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default memo(ServiceProfessionalGovernance);
